export const registrationButtonConfig = {
  type: '@sitebase/registration-button',
  data: {
    id: 'hrs-action__registration-button',
  },
  children: [],
};

export const registrationPlugin = {
  beforeRender({ header }) {
    header.actions.children.push(registrationButtonConfig);
  },
};
